import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/dentlab/src/components/ui/dialog";
import { Button } from "@/dentlab/src/components/ui/button";
import { useTemplatesStore } from "@/dentlab/src/store/Templates";

interface TemplateDeletionDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	templateIds: number[];
	itemType: "tariff" | "article";
	itemCode: string;
	canFallbackToDefault: boolean;
	onCancel: () => void;
	onFallbackToDefault: () => void;
	onRemoveFromTemplates: () => void;
}

export const TemplateDeletionDialog: React.FC<TemplateDeletionDialogProps> = ({
	open,
	onOpenChange,
	templateIds,
	itemType,
	itemCode,
	canFallbackToDefault,
	onCancel,
	onFallbackToDefault,
	onRemoveFromTemplates,
}) => {
	const { templatesLookup } = useTemplatesStore((state) => ({
		templatesLookup: state.templatesLookup,
	}));

	const templateNames = templateIds
		.map((id) => templatesLookup[id]?.name || templatesLookup[id]?.code || `Template ${id}`)
		.filter(Boolean);

	const itemTypeLabel = itemType === "tariff" ? "Tarif" : "Artikel";

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>{itemTypeLabel} {itemTypeLabel === "Tarif" ? "deaktivieren" : "löschen"}</DialogTitle>
					<DialogDescription asChild>
						<div>
							<p className="mb-2">
								Der {itemTypeLabel} "{itemCode}" wird in folgenden Vorlagen verwendet:
							</p>
							<ul className="list-disc list-inside mb-2 max-h-40 overflow-y-auto">
								{templateNames.map((name, index) => (
									<li key={index} className="text-sm">
										{name}
									</li>
								))}
							</ul>
						</div>
					</DialogDescription>
				</DialogHeader>
				<DialogFooter className="flex-col sm:flex-row gap-2">
					<Button variant="outline" onClick={onCancel}>Abbrechen</Button>
					{canFallbackToDefault && (
						<Button variant="outline" onClick={onFallbackToDefault}>
							Auf Standard zurücksetzen
						</Button>
					)}
					<Button variant="destructive" onClick={onRemoveFromTemplates}>
						Aus Vorlagen entfernen
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};
